<template>
  <div class="charging-operation">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <div class="sub-title">基本信息</div>
      <el-form-item label="仓库" prop="warehouseId">
        <el-select class="white" v-model="ruleForm.warehouseId" placeholder="请选择" @change="changeWarehouse">
          <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectId">
        <el-select class="white" v-model="ruleForm.projectId" placeholder="请选择">
          <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运单日期" prop="date">
        <el-date-picker v-model="ruleForm.date" type="date" placeholder="请选择" :picker-options="pickerOptions"
          format="yyyy-MM-dd" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <div class="sub-title">物流信息</div>
      <el-form-item label="快递类型" prop="expressType">
        <el-select class="white" clearable v-model="ruleForm.expressType" placeholder="请选择">
          <el-option v-for="item in expressList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="运单号" prop="expressNo">
        <el-input class="white input-div" v-model="ruleForm.expressNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="到件地址" prop="address">
        <el-cascader ref="manualOrderProvincesCity" v-model="ruleForm.address" :props="defaultParams"
          :options="provincesAndCitiesAddressList"></el-cascader>
      </el-form-item>
      <el-form-item label="货主单号" prop="customerOrderCode">
        <el-input class="white input-div" v-model="ruleForm.customerOrderCode" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="重量" prop="orderWeight">
        <el-input class="white input-div" v-model="ruleForm.orderWeight" placeholder="请输入"
          @input="inputGetDecimalNums('orderWeight',ruleForm.orderWeight)" clearable></el-input>
      </el-form-item>
      <el-form-item label="发货件数" prop="shippedNumber">
        <el-input class="white input-div" v-model="ruleForm.shippedNumber" placeholder="请输入"
          @input="inputGetPositiveIntegerNums('shippedNumber',ruleForm.shippedNumber)" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="运费（元）" prop="logisticIncome">
        <el-input class="white input-div" v-model="ruleForm.logisticIncome" placeholder="请输入"
          @input="inputGetDecimalNums('logisticIncome', ruleForm.logisticIncome)" clearable></el-input>
      </el-form-item> -->
      <div class="sub-title">其他信息</div>
      <el-form-item label="备注" prop="remarks">
        <el-input type="textarea" class="white remarks" v-model="ruleForm.remarks" placeholder="请输入"
          clearable></el-input>
      </el-form-item>
      <div class="footer">
        <el-button @click="cancel('ruleForm')">清空</el-button>
        <el-button class="btn-blue" @click="submitForm('ruleForm')">保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import ManualOrder from "models/production/manual-order";
import warehouseMixins from "@/common/mixins/warehouse.js"
import projectMixins from 'common/mixins/project.js'
import expressMixins from "@/common/mixins/express.js"
import defaultAddressMixins from "@/common/mixins/default-address.js"
import { formatTimeToDate, getPositiveInteger, getDecimal } from "common/js/util";
export default {
  mixins: [warehouseMixins, projectMixins, expressMixins, defaultAddressMixins],
  data() {
    const validatePass = (rule, value, callback) => {
      this.initValidate(value, callback)
    };
    const validateLogisticIncome = (rule, value, callback) => {
      if (value > 1000000) {
        callback(new Error('运费限制8位,例如（xxxxxx.xx)'));
      } else {
        callback();
      }
    };
    return {
      //设置今天以后不可选
      pickerOptions: {
        //限制时间
        selectableRange: this.selectableRange(),
        // 限制日期
        disabledDate: this.disabledDate,
      },
      ruleForm: {
        warehouseId: "",
        expressType: '',
        date: formatTimeToDate(new Date()),
        projectId: "",
        remarks: "",
        expressNo: "",
        customerOrderCode: "",
        orderWeight: "",
        shippedNumber: "",
        // logisticIncome: 0,
        address: []
      },
      rules: {
        warehouseId: [
          {
            required: true,
            message: "请选择仓库",
            trigger: "change",
          },
        ],
        date: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        projectId: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
        ],
        expressType: [{ required: true, message: "请选择快递类型", trigger: "change" }],
        expressNo: [{ required: true, validator: validatePass, trigger: "blur" }],
        address: [{ required: true, message: "请选择到件地址", trigger: "change" }],
        logisticIncome: [
          { required: false, validator: validateLogisticIncome, trigger: "blur" }
        ],
      },
    };
  },

  async created() {
    this.initExpressList()
    await this.initAsyncWarehouse()
    this.ruleForm.warehouseId = this.warehouseList[0].id;
    this.initProjectListByWarehouse(this.ruleForm.warehouseId)
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.ruleForm.warehouseId;
          let billDate = this.ruleForm.date;
          let projectId = this.ruleForm.projectId;
          let expressType = this.ruleForm.expressType;
          let expressNo = this.ruleForm.expressNo;
          let customerOrderCode = this.ruleForm.customerOrderCode;
          let shippedNumber = Number(this.ruleForm.shippedNumber);
          let logisticIncome = Number(this.ruleForm.logisticIncome);
          let orderWeight = Number(this.ruleForm.orderWeight);
          let remark = this.ruleForm.remarks;
          let address = this.ruleForm.address;
          let receiveProvince = address[0]
          let receiveCity = address[1]
          let receiveCounty = address[2]
          let warehouseObj = this.warehouseList.find(item => { return item.id == warehouseId })
          let projectObj = this.projectList.find(item => { return item.id == projectId })
          let expressObj = this.expressList.find(item => { return item.id == expressType })
          let warehouseName = warehouseObj.name
          let projectName = projectObj.name
          let expressName = expressObj.name
          let data = {
            warehouseId,
            warehouseName,
            projectId,
            projectName,
            billDate,
            remark,
            expressNo,
            expressType,
            expressName,
            customerOrderCode,
            logisticIncome,
            shippedNumber,
            orderWeight,
            receiveProvince,
            receiveCity,
            receiveCounty
          };

          ManualOrder.postUploadManualOrder(data).then((res) => {
            if (res.success) {
              this.$message.success('保存成功');
              this.cancel('ruleForm')
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /** 
     * @description 运单号是否存在
    */
    initValidate(value, callback) {
      if (!value) {
        callback(new Error('请输入运单号'));
      } else {
        if (value.length > 32) {
          callback(new Error('运单号不可超出32位'));
        } else {
          ManualOrder.getExpressNoIsExist(value).then((res) => {
            if (res.success) {
              if (res.result) {
                callback(new Error('该运单号已存在，无法登记'));
              } else {
                callback()
              }
            } else {
              this.$message.error(res.message);
            }
          });
        }
      }
    },

    cancel(formName) {
      // 清空级联选择器选中状态
      this.$refs.manualOrderProvincesCity.$refs.panel.clearCheckedNodes()
      // 清除⾼亮
      this.$refs.manualOrderProvincesCity.$refs.panel.activePath = []
      this.$refs.manualOrderProvincesCity.$refs.panel.syncActivePath(); // 初始化（只展示一级节点）
      this.$refs[formName].resetFields();
      this.ruleForm.warehouseId = this.warehouseList[0].id;
    },

    /* 限制数量为正整数 */
    inputGetPositiveIntegerNums(key, val) {
      this.ruleForm[key] = getPositiveInteger(val);
    },

    /* 限制数量为2位小说, 不包含负数 */
    inputGetDecimalNums(key, val) {
      this.ruleForm[key] = getDecimal(val);
    },

    selectableRange() {
      let date = new Date();
      let hour = date.getHours();
      hour = hour > 9 ? hour : "0" + hour;
      let minute = date.getMinutes();
      minute = minute > 9 ? minute : "0" + minute;
      let second = date.getSeconds();
      second = second > 9 ? second : "0" + second;
      let time = `${hour}:${minute}:${second}`;
      const selectableRange = `${time}-23:59:59`;
      return selectableRange;
    },

    disabledDate(date) {
      //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
      return date.getTime() > Date.now();
    },

    /** 
     * @description 根据选中仓库获取项目
    */
    changeWarehouse() {
      this.ruleForm.projectId = ""
      this.initProjectListByWarehouse(this.ruleForm.warehouseId)
    }
  },
};
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/charging-operation.scss";
</style>
